export const {
  AlignmentControl,
  BorderControl,
  BorderRadiusControl,
  ChoiceGroup,
  ColorControl,
  IconPicker,
  ImagePicker,
  LongTextControl,
  Modal,
  NetIcon,
  PanelBody,
  RadioGroup,
  RangeControl,
  SelectControl,
  SizeControl,
  SizeXYControl,
  SpacingControl,
  SwitchControl,
  Tab,
  TextControl,
  UnitControl,
  RichText,
} = WPTB.modules.components;

export const { EnhancedControl, Notifications, BuilderApp, ToolbarBtn } =
  WPTB.components;
